module.exports = __webpack_public_path__ + "img/Z86_14.89a10e94.jpg";